module.exports = __webpack_public_path__ + "s/img/Chill_D_4.df34e24e.jpg";